/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import styles from './heading.scss';

export enum HeadingType {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
}

type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> & {
  kind?: HeadingType,
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  className?: React.HTMLAttributes<HTMLHeadingElement>['className'],
  children: React.HTMLAttributes<HTMLHeadingElement>['children']
};

function Heading({
  kind = HeadingType.H1,
  className = '',
  tag,
  children,
  ...props
}: HeadingProps) {
  const HeadingTag = React.useMemo(() => {
    if (tag) return tag;

    switch (kind) {
      case HeadingType.H1: return 'h1';
      case HeadingType.H2: return 'h2';
      case HeadingType.H3: return 'h3';
      case HeadingType.H4: return 'h4';
      case HeadingType.H5: return 'h5';
      case HeadingType.H6: return 'h6';
      default: return 'h1';
    }
  }, [tag, kind]);

  return (
    <HeadingTag
      className={classnames(styles.heading, className, {
        [styles.h1]: kind === HeadingType.H1,
        [styles.h2]: kind === HeadingType.H2,
        [styles.h3]: kind === HeadingType.H3,
        [styles.h4]: kind === HeadingType.H4,
        [styles.h5]: kind === HeadingType.H5,
        [styles.h6]: kind === HeadingType.H6,
      })}
      {...props}
    >
      {children}
    </HeadingTag>
  );
}

export default Heading;
